var _g, _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreisWecker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "preis-wecker-icon",
    width: 56,
    height: 61,
    viewBox: "0 0 56 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23 57C23.167 58.1087 23.7653 59.1245 24.6844 59.8597C25.6034 60.595 26.7811 61 28 61C29.2189 61 30.3966 60.595 31.3156 59.8597C32.2347 59.1245 32.833 58.1087 33 57H23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8594 0C28.5246 7.29651e-05 29.1624 0.265398 29.6328 0.737305C30.1033 1.20925 30.3681 1.84917 30.3682 2.5166C30.3682 3.90699 31.4079 5.06073 32.7559 5.40137C36.7297 6.40559 40.3286 8.5983 43.0576 11.7158C46.3241 15.4474 48.1197 20.2477 48.1074 25.2139V34.5273C48.3428 37.6891 49.2056 40.7718 50.6445 43.5947C51.9621 45.6402 53.5488 47.498 55.3613 49.1182C55.7676 49.4778 56 49.9945 56 50.5371V51.335C55.9998 53.359 54.359 54.9998 52.335 55H3.66602C1.64175 55 0.000249434 53.3591 0 51.335V50.5371C0 49.9945 0.232415 49.4778 0.638672 49.1182C2.42423 47.4926 3.9853 45.6351 5.28027 43.5947C6.71931 40.7717 7.76464 37.6619 8 34.5V34.667L35.9521 47.5186C21.6224 40.75 8.74935 27.334 8.03223 24.2432C8.2717 19.7238 9.85193 15.2052 12.8018 11.8018C15.4825 8.70883 19.0174 6.5133 22.9307 5.47363C24.2989 5.11015 25.3506 3.93219 25.3506 2.5166C25.3506 1.84925 25.6146 1.20924 26.085 0.737305C26.5555 0.265331 27.194 0 27.8594 0Z"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        #preis-wecker-icon g {\n            fill: url(#bg);\n        }\n        .dark #preis-wecker-icon g {\n            fill: url(#bg-dark);\n        }\n    ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5 30.5) rotate(90) scale(30.5 31.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D8FFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bg-dark",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29 26) rotate(87.546) scale(35.0321)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FFD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EC48D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreisWecker);
export default __webpack_public_path__ + "static/media/preis-wecker.f351659968038051c15748bbc8661988.svg";
export { ForwardRef as ReactComponent };